import React, { FC } from 'react';
import { EnergyRating2D } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';

import { EnergimerkeV2023 as EnergimerkeV2023Type } from '../../../types/energimerke';

interface Props {
  energimerke: EnergimerkeV2023Type;
}
const EnergimerkeV2023: FC<Props> = ({ energimerke }) => {
  const { t } = useTranslation();
  const { energikarakter, oppvarmingskarakter } = energimerke;

  const screenReaderCaption = t('energyLabel2D.srCaption', {
    heatingGrade: t('energyLabel.heatingGrade', {
      context: oppvarmingskarakter
    }),
    energyGrade: energikarakter
  });

  if (!energikarakter || !oppvarmingskarakter) {
    return null;
  }

  return (
    <EnergyRating2D
      energyAxisLabel={t('energyLabel.energyGrade')}
      heatingAxisLabel={t('energyLabel.heatingGrade')}
      energyGrade={energikarakter}
      heatingGrade={oppvarmingskarakter}
      screenReaderCaption={screenReaderCaption}
    />
  );
};

export default EnergimerkeV2023;
